module.exports = __webpack_public_path__ + "img/NAR-487x500.15282189.png";